export default __webpack_public_path__ + "static/media/CE.d8b12d8b.svg";